<!--
 * @Author: your name
 * @Date: 2021-07-05 15:57:49
 * @LastEditTime: 2021-07-16 17:44:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\components\templates\customCategoriesUnit.vue
-->
<template>
  <div class="content-tabs">
     <el-tabs v-model="activeName" @tab-click.native.prevent="handleClick">
        <el-tab-pane v-for="(item,index) in customCategoriesList" :key="index" :label="item.name" :name="item.name"></el-tab-pane>
  </el-tabs>
  </div>
</template>

<script>
export default {
   props:{
         customCategoriesList: {
          type: Array,
          default: function () {
            return []
          }
        },
  },
  data(){
    return{
      activeName:'商城首页'
    }
  },
  methods:{
    handleClick(){
      
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/theme.scss';
.content-tabs{
  width: 980px;
  height: 40px;
  background: #fff;
  padding:0 40px;
  ::v-deep .el-tabs__nav-wrap:after{
    height: 0px;
  }
  ::v-deep .el-tabs__item.is-active{
    color:$main-col;
  }
  ::v-deep .el-tabs__item{
     color:$c3;
  }
  ::v-deep .el-tabs__item:hover{
     color:$main-col-2;
  }
  ::v-deep  .el-tabs__active-bar{
    display: none;
  }
   
}
</style>
